import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import IconButton from '@material-ui/core/IconButton';
import i18next from 'i18next';


import SimpleMenu from './SimpleMenu';

// based on https://material-ui.com/demos/app-bar/ 

const styles = {
    root: {
        flexGrow: 1,
    },
    flex: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
};

class ButtonAppBar extends Component {

    constructor(props) {
        super(props);
        this.classes = props.classes;

        this.backClicked = this.backClicked.bind(this);
    }

    backClicked() {
        this.props.history.push('/');
    }

    render() {
        return (
            <div className={this.classes.root}>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton color="inherit" aria-label="Back" onClick={this.backClicked}>
                            {/* for showint the back icon, we first check that we are not in root page. second the direction of the arrow (for rtl languages.) */}
                            {!(this.props.location['pathname'] === '/') ? (i18next.dir() === 'ltr' ? <ArrowBackIosIcon /> : <ArrowForwardIosIcon/>) : null}
                        </IconButton>
                        <Typography variant="title" color="inherit" className={this.classes.flex}>
                            Points-O-Rama
                        </Typography>
                        {("propMenuHandlers" in this.props)?<SimpleMenu propMenuHandlers={this.props.propMenuHandlers} />:null}
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
}

ButtonAppBar.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(ButtonAppBar));



// WEBPACK FOOTER //
// ./src/components/material-ui/ButtonAppBar.js